const Home = () => {
  return (
    <div className="Pages">
      <h1>Welcome to Oberman Financial Coaching</h1>

      Are you ready to take control of your finances and achieve your financial dreams?

      At Oberman Financial Coaching, we are dedicated to providing you with the guidance, support, and personalized strategies needed to make your financial goals a reality. Whether you are looking to pay off debt, build savings, invest wisely, or simply gain a better understanding of your financial situation, our expert financial coaches are here to help.

      <h2>Why Financial Coaching Matters</h2>

      In today's fast-paced world, managing your finances can be overwhelming. With countless options for investing, saving, and spending, it's easy to feel lost or uncertain about the best path forward. This is where financial coaching comes in.
      <ol><li>
        <b>Personalized Guidance:</b> Financial coaching is all about you. Unlike generic financial advice you might find online or in books, our coaching sessions are tailored to your unique situation and goals. We take the time to understand your specific financial needs, aspirations, and challenges, creating a customized plan that fits your lifestyle.
      </li>
        <li>
          <b>Accountability and Support</b> One of the biggest challenges in achieving financial goals is staying motivated and accountable. Our financial coaches provide ongoing support and check-ins to ensure you stay on track. We are your partners in this journey, celebrating your successes and helping you navigate any obstacles that arise.
        </li><li>
          <b>Education and Empowerment:</b> Knowledge is power. Our coaches are committed to helping you understand the "why" behind every financial decision. We provide you with the tools and education needed to make informed choices, empowering you to take control of your financial future with confidence.
        </li>
        <li>
          <b>Stress Reduction:</b> Financial stress is a common issue that can affect your overall well-being. By working with a financial coach, you can alleviate this stress and gain peace of mind. We help you create a clear, actionable plan, so you no longer have to worry about money management alone.
        </li>
        <li>
          <b>Long-Term Success:</b> Financial coaching is not just about quick fixes; it's about building a solid foundation for long-term financial success. We focus on sustainable strategies that will continue to benefit you for years to come. Our goal is to help you develop healthy financial habits and achieve lasting financial security.
        </li>
      </ol>

      <h2>Our Approach</h2>

      At Oberman Financial Coaching, we believe that everyone deserves the opportunity to achieve financial freedom.

      Our approach is client - centered, compassionate, and results - driven.We offer a range of services, including:
      <ol>
        <li>
          <b>One-on-One Coaching:</b> Personalized sessions tailored to your unique financial situation and goals.</li>

        <li>
          <b>Workshops and Seminars:</b> Group sessions on various financial topics to enhance your knowledge and skills.</li>

        <li>
          <b>Online Resources:</b> Access to a wealth of tools, articles, and guides to support your financial journey.</li>
      </ol>
      <h2>Get Started Today!</h2>

      Don't wait to take control of your financial future.
      Contact us today to schedule your free consultation and start your journey toward financial empowerment.
      At Oberman Financial Coaching, we are here to help you every step of the way.

      Ready to make those financial dreams come true ? 🏡💰

    </div >

  );
};

export default Home;